<div class="modal-header">
    <h3 class="modal-title mb-0">Topup</h3>
</div>
<div class="modal-body">
    <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
        <div class="mb-3">
            <label for="amount" class="form-label">Amount</label>
            <input type="number" class="form-control" id="amount" name="amount" #amount="ngModel" [(ngModel)]="data.amount" required>
        </div>
        <div class="mb-3">
            <label for="bank_id" class="form-label">Bank</label>
            <select class="form-control" id="bank_id" name="bank" #bank_id="ngModel" [(ngModel)]="data.bank_id" required>
                <option [value]="b.id" *ngFor="let b of banks">{{b.title}} ({{b.balance}})</option>
            </select>
        </div>
        <div class="d-flex flex-row justify-content-between">
            <button type="submit" class="btn btn-primary">Submit</button>
            <!-- <button type="button" class="btn btn-secondary" (click)="closeEvent.emit(false)">Cancel</button> -->
        </div>
    </form>
</div>